import React, { useState } from "react";

/* ============================================================
 ShareButtons — X / WhatsApp / Copy Link. Used on TrackDetail
 + anywhere else we need to spread a track URL. Every share
 drives a click, every click is a potential upvote.
 ============================================================ */

export default function ShareButtons({ url, text }) {
 const [copied, setCopied] = useState(false);

 const twitter = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
 const whatsapp = `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`;
 const telegram = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;

 const copyLink = async () => {
 try {
 await navigator.clipboard.writeText(url);
 setCopied(true);
 setTimeout(() => setCopied(false), 1800);
 } catch (e) {}
 };

 return (
 <div className="flex flex-wrap gap-2" data-testid="share-buttons">
 <a href={twitter} target="_blank" rel="noopener noreferrer"
 data-testid="share-x"
 className="bg-black border-2 border-white text-white font-mono text-xs tracking-widest px-4 py-2 hover:bg-white hover:text-black transition-colors">
 𝕏 SHARE ON X
 </a>
 <a href={whatsapp} target="_blank" rel="noopener noreferrer"
 data-testid="share-whatsapp"
 className="bg-[#25D366] text-black font-mono text-xs tracking-widest px-4 py-2 hover:bg-white transition-colors">
 WHATSAPP
 </a>
 <a href={telegram} target="_blank" rel="noopener noreferrer"
 data-testid="share-telegram"
 className="bg-[#0088cc] text-white font-mono text-xs tracking-widest px-4 py-2 hover:bg-white hover:text-black transition-colors">
 TELEGRAM
 </a>
 <button onClick={copyLink}
 data-testid="share-copy"
 className={`font-mono text-xs tracking-widest px-4 py-2 border-2 transition-colors ${
 copied ? "border-yt-judge bg-yt-judge text-black" : "border-yt-yellow text-yt-yellow hover:bg-yt-yellow hover:text-black"
 }`}>
 {copied ? "✓ COPIED" : "COPY LINK"}
 </button>
 </div>
 );
}
